import { useSearchParams } from '@remix-run/react';

const useRecommendationsSignUpModal = () => {
  const [searchParams] = useSearchParams();
  const isModalOpen = searchParams.get('recommendations') === 'true';

  return {
    isModalOpen: isModalOpen,
  };
};

export default useRecommendationsSignUpModal;
